





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { RouteName } from '@/router/index'

@Component({})
export default class Indicator extends Vue {
  @Prop({ default: () => '' }) public status!: number
  private get routeName() {
    return RouteName
  }
}
